import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FormIndicationProfile } from './FormIndicationProfile';
import './styleDialog.css'
export const DialogProfileIndications = (props) => {

    const {
            visibleDialog, setVisibleDialog, handleSelectValuesIndication, handleSelectValuesIndication2, dataIndication, dataIndicationLab,
            handleListProfiles, listIndication, listIndicationLab, handleSaveAllIndications
    } = props;

    return (
       <Dialog 
            header="Indicaciones de Perfiles" 
            visible={visibleDialog}  
            onHide={() => setVisibleDialog(false)} 
            closable={true}
            style={{ width: '80vw' }}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <button className="btn btn-outline-primary btn-sm" onClick={handleSaveAllIndications} type="submit" >
                        Guardar
                    </button>

                    <button className="btn btn-danger btn-sm" onClick={() => setVisibleDialog(false)}>
                        Cerrar
                    </button>
                </div>
            }
        >

            <FormIndicationProfile
                { 
                    ...{ handleSelectValuesIndication, handleSelectValuesIndication2, dataIndication, dataIndicationLab, handleListProfiles,
                        listIndication, listIndicationLab


                } }
            />    
        
        </Dialog>

    );
};
